<template>
  <form @submit.prevent="submit()">
    <div v-if="!restricted && isCurrentExpert" class="offer-button-box pa-3">
      <v-dialog v-model="offerPopup" width="480px">
        <v-btn primary outline slot="activator">{{ offerTitle || $t("accounts.profile.labels.offerId") }}</v-btn>
        <v-card>
          <v-card-title>{{ $t('accounts.profile.offer') }}</v-card-title>
          <v-card-text>
            <v-text-field v-model="offerTitle" :label="$t('accounts.profile.labels.offerTitle')"/>
            <v-switch v-model="internalOffer" :label="$t('accounts.profile.labels.offerSwitch')" />
            <v-list v-if="internalOffer" class="offers-list">
              <v-list-tile v-for="offer in offers" :key="offer.id">
                <v-list-tile-action>
                  <v-radio v-model="offerId" :value="offer.id"></v-radio>
                </v-list-tile-action>
                <v-list-tile-content @click="offerId = offer.id">
                  <v-list-tile-title>
                    <span v-if="!offer.is_public">
                      {{ $t('accounts.profile.private') }}
                    </span>
                    {{ offer.title }}
                  </v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action @click="offerId = offer.id">
                  <price :value="offer.price"></price>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-text-field v-else v-model="offerLink" :label="$t('accounts.profile.labels.offerLink')"/>
          </v-card-text>
          <v-card-row actions>
            <v-btn primary light ripple @click.native="offerPopup = false">{{ $t('accounts.profile.valid') }}</v-btn>
          </v-card-row>
        </v-card>
      </v-dialog>
      <v-btn v-if="offerId || offerLink" icon @click.native="deleteOffer()"><v-icon class="primary--text">close</v-icon></v-btn>
    </div>
    <component
      v-for="input in inputs" :key="input.key"
      :is="input.component"
      :config="input"
      v-model="$data[input.key]">
    </component>


    <v-card-row actions>
      <v-btn
        type="submit"
        primary light ripple
        :loading="loading">
        {{ $t('accounts.profile.save') }}
      </v-btn>
    </v-card-row>
  </form>
</template>

<script>
  import expert from '@/mixins/expert'
  import Expert from '@/api/currentExpert'
  import { Price } from '@/components/formatters'
  import {
    TextInput,
    LanguageInput,
    FileInput,
    RichTextInput,
    OfferInput
  } from '@/components/inputs'
  import { mapGetters, mapActions } from 'vuex'
  export default {
    components: {
      OfferInput,
      Price
    },
    mixins: [expert],
    data () {
      return {
        offerPopup: false,
        error: {},
        cover: (this.expert.picture || {}).normal,
        avatar: this.expert.picture.thumb,
        jobTitle: this.expert.job_title,
        nickname: this.expert.nickname,
        description: this.expert.description.full || '',
        keywords: this.expert.keywords.join(', '),
        video: this.expert.video,
        resume: this.expert.description.short,
        languages: this.expert.languages,
        offerId: this.expert.offer_id,
        offerLink: this.expert.offer_link,
        offerTitle: this.expert.offer_title,
        internalOffer: !this.expert.offer_link
      }
    },
    computed: {
      ...mapGetters({
        currentUser: 'skiliko/session/currentUser',
        services: 'skiliko/services/servicesByScope'
      }),
      inputs () {
        return [
          { key: 'cover', component: FileInput, path: 'covers' },
          { key: 'avatar', component: FileInput, path: 'avatars' },
          { key: 'jobTitle', required: true, component: TextInput },
          { key: 'nickname', required: true, component: TextInput },
          { key: 'description', required: true, component: RichTextInput },
          { key: 'keywords', component: TextInput },
          { key: 'video', type: 'url', component: TextInput },
          { key: 'languages', type: 'language', component: LanguageInput },
          { key: 'resume', multiLine: true, counter: true, max: 150, component: TextInput }
        ]
          .map(input => ({
            ...input,
            label: this.$t(`accounts.profile.labels.${input.key}`),
            errors: (this.error[input.key] || []).map(e => () => e)
          }))
      },
      isCurrentExpert () {
        return this.currentUser.id === this.expert.id
      },
      restricted () {
        return Expert.isRestricted(this.expert)
      },
      offers () {
        return [
          ...this.services.public,
          ...this.services.private
        ].filter(x => x.admin_ids.indexOf(this.expert.id) >= 0)
      }
    },
    methods: {
      ...mapActions({
        saveCurrentExpert: 'skiliko/session/updateCurrentUser',
        saveOtherExpert: 'skiliko/experts/save',
        fetchOffers: 'skiliko/services/fetchAll'
      }),
      deleteOffer () {
        this.offerId = this.offerTitle = this.offerLink = null
      },
      submit () {
        const data = {
          job_title: this.jobTitle,
          nickname: this.nickname,
          keywords: this.keywords,
          video: this.video,
          languages: this.languages,
          description: {
            full: this.description,
            short: this.resume
          },
          picture: {
            normal: this.cover,
            thumb: this.avatar
          },
          offer_title: this.offerTitle,
          offer_id: this.internalOffer ? this.offerId : null,
          offer_link: this.internalOffer ? null : this.offerLink
        }
        const id = this.expert.id
        ;(this.isCurrentExpert
          ? this.saveCurrentExpert({ data })
          : this.saveOtherExpert({ id, data }))
          .catch(({ response }) => (this.error = (response || {}).data || {}))
      }
    },
    mounted () {
      this.fetchOffers({ scope: 'public' })
      this.fetchOffers({ scope: 'private' })
    }
  }
</script>

<style scoped>
  .offer-button-box {
    position: absolute;
    right: 0;
  }

  .offers-list {
    max-height: 250px;
    height: 250px;
    overflow: scroll;
    border: solid 1px rgba(0,0,0,0.17);
  }
</style>



// WEBPACK FOOTER //
// src/components/account/Profile.vue